import { render, staticRenderFns } from "./targetModal.vue?vue&type=template&id=5a20385b&scoped=true"
import script from "./targetModal.vue?vue&type=script&lang=js"
export * from "./targetModal.vue?vue&type=script&lang=js"
import style0 from "./targetModal.vue?vue&type=style&index=0&id=5a20385b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a20385b",
  null
  
)

export default component.exports